import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import AppProvider from 'providers/AppProvider';
import { ProvideAuth } from './hooks/useAuth';
import { EntityProvider } from './hooks/useEntities';
import * as React from 'react';
import ReactDOM from 'react-dom/client';
import BreakpointsProvider from 'providers/BreakpointsProvider';
import SettingsPanelProvider from 'providers/SettingsPanelProvider';
import { RouterProvider } from 'react-router-dom';
import { router } from 'Routes';

Amplify.configure(awsExports);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AppProvider>
      <SettingsPanelProvider>
        <BreakpointsProvider>
          <ProvideAuth>
            <EntityProvider>
              <RouterProvider router={router} />
            </EntityProvider>
          </ProvideAuth>
        </BreakpointsProvider>
      </SettingsPanelProvider>
    </AppProvider>
  </React.StrictMode>
);
